import { render, staticRenderFns } from "./BagPromotion.vue?vue&type=template&id=65e3bc86&scoped=true"
import script from "./BagPromotion.vue?vue&type=script&lang=js"
export * from "./BagPromotion.vue?vue&type=script&lang=js"
import style0 from "./BagPromotion.vue?vue&type=style&index=0&id=65e3bc86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e3bc86",
  null
  
)

export default component.exports